module.exports = __webpack_public_path__ + "img/index-kinds-canledar.67452c37.png";